export default function jqueryPopupmenu ($) {
  'use strict';

  $.fn.popupmenudropdown = function (options) {
    options = _.extend({
      left: null,
      forceBottom: false,
      onShow: $.noop,
      onHide: $.noop
    }, options);

    const windowHeight = $(window).height();

    return this.each(function (e) {
      const $items = $(this).find('>.ui-dropdown-items');

      const toggleDropdownItems = function ($container, show, callback) {
        $container.each(function () {
          const isRootButton = !!$(this).parents('.root-popupmenu').length;

          isRootButton && $(this).css('visibility', show ? 'visible' : 'hidden');
          isRootButton || $(this)['slide' + (show ? 'Down' : 'Up')]('fast', callback);
        });
        show || $container.removeClass('active');
      };

      if (!$items.hasClass('ui-dropdown-div') && $items.children().length) {
        if ($items.is('.horizontal')) {
          $(this).append('<i class="icon-spacing_2"></i>');
        } else {
          $(this).append('<i class="desygner-icon-arrow-down"></i>');
        }
      }

      $(this).off('click').on('click', function (e, opts) {
        opts = opts || {};
        const $target = $(e.target);
        const noCloseSelector = ':not(input, select, label, .ui-dropdown-items, option, .radiomark, .desygner-custom-check label)';
        let show = false;

        if (opts.keepHidden !== true && ($target.is($(this)) || $target.is($(this).find(noCloseSelector)))) {
          if (($items.css('display') === 'none' || $items.css('visibility') === 'hidden') && $items.children().length) {
            // hide all
            toggleDropdownItems($('.ui-dropdown-items'), show);
            show = true;

            const visibleMenuRect = this.closest('#element-popupmenu')?.getBoundingClientRect();
            const menuRect = getMenuBB();
            const buttonRect = this.parentElement.getBoundingClientRect();
            $items.css({
              left: '',
              right: ''
            });

            $(this).addClass('active');
            const sideBarResizeButton = document?.querySelector('#sidebar-resize-button')?.getBoundingClientRect();
            if ($items.hasClass('fullscreen')) {
              $items.css('left', ($('#editor').offset().left + 2));
            } else if ($items.hasClass('ui-dropdown-modal')) {
              const parentElement = e.target.closest('.element-popupmenu')?.parentElement;
              const closeButton = parentElement?.querySelector('.special-buttons');
              const closeButtonWidth = closeButton?.getBoundingClientRect().width || 0;
              $items.css('left', `${(visibleMenuRect.width - $items.width()) / 2 - closeButtonWidth}px`);
            } else if ($items.parents('.common-buttons').length) {
              $items.css('right', 0);
            } else if ($items.parents('.root-buttons').length) {
              $items.css('left', 0);
            } else if (typeof options.left === 'number') {
              $items.css('left', options.left);
            } else if (buttonRect.left + $items.width() <= visibleMenuRect.right) {
              $items.css('left', 0);
            } else if (buttonRect.right - $items.width() >= visibleMenuRect.left + sideBarResizeButton.width) {
              $items.css('right', 0);
            } else {
              const paddingLeft = 8;
              $items.css('left', visibleMenuRect.left - buttonRect.left + sideBarResizeButton.width + paddingLeft);
            }

            // Bottom/top position
            if (!options.forceBottom &&
              ((INKIVE.C.IS_MOBILE && (buttonRect.top - $items.height() + 150 > menuRect.top)) ||
                (!INKIVE.C.IS_MOBILE && (buttonRect.bottom + $items.height() + 10 > windowHeight)))) {
              $items.addClass('top');
            } else {
              $items.removeClass('top');
            }
            toggleDropdownItems($items, show, options.onShow);
          } else if (
            !$target.parents('[data-action=on_fontfamily]').length &&
            $target.attr('id') !== 'header-and-footer-configuration' &&
            !$target.parents('#header-and-footer-configuration').length &&
            !$target.parents('[data-id="edit-ordered-list"]').length &&
            !$target.parents('[data-id="edit-cell-border"]').length &&
            !$target.parents('[data-id="edit-bullet-points"]').length
          ) {
            const isClickingOnSameMenu = $items.parent()[0] === e.target?.closest('a.ui-dropdown');
            const dropdown = $items.parent('.ui-dropdown');
            const closeMenuActions = [
              'on_rootDrawing',
              'on_rootShapes',
              'on_rootFrames',
              'colormap-circle',
              'on_set-link'
            ].some(action => dropdown.data('action') === action);

            if (isClickingOnSameMenu && !closeMenuActions) {
              return;
            }

            $(this).removeClass('active');

            $items.find('.ui-dropdown-items.sub').hide();
            toggleDropdownItems($items, show, options.onHide);
          }

          INKIVE.EditorFacade.trigger('element.menu.dropdown', {
            show,
            action: $(this).attr('data-action'),
            type: $(this).attr('type')
          });
        }

        function getMenuBB () {
          let menuRect = $('.menu').get(0).getBoundingClientRect();
          const $toolPanel = $('#tool-panel');
          if ($toolPanel.is('.active')) {
            const offset = $toolPanel.offset();

            menuRect = {
              right: menuRect.right - offset.left,
              left: menuRect.left - offset.left,
              bottom: menuRect.bottom,
              height: menuRect.height,
              top: menuRect.top,
              width: menuRect.width
            };
          }

          return menuRect;
        }
      });

      $items.off('click').on('click', 'li:not(.ui-font-selection)', function (e) {
        const $target = $(this).parents('.ui-dropdown');
        const val = $(this).find('[role=menuitem]').html();

        if (val && !$(this).is('.font-locale')) {
          const fontFamily = $(this).find('[role=menuitem]').attr('data-font-family');
          const fontWeight = $(this).find('[role=menuitem]').attr('data-font-weight');
          const fontStyle = $(this).find('[role=menuitem]').attr('data-font-style');
          const headingTitle = this.querySelector('[role=menuitem]').dataset.headingTitle;
          const heading = this.querySelector('[role=menuitem]').dataset.heading;
          const fontStretch = this.querySelector('[role=menuitem]').dataset.fontStretch;

          fontFamily && $target.find('.ui-dropdown-title').html(fontFamily);
          headingTitle && $target.find('.ui-dropdown-title').html(headingTitle);

          $target.trigger('change', [val, fontFamily, fontWeight, heading, fontStretch, fontStyle]);
          fontFamily && INKIVE.DesignFacade.trigger('text.update.font', { family: fontFamily });
          if ($target.attr('type') === 'toggle') {
            // hide all
            toggleDropdownItems($('.ui-dropdown-items'), false);
            $('#sidebar-resize-button').removeClass('collapse-hidden');
          }

          if ($(this).find('a').data('type') === 'all') {
            INKIVE.Menus.elementPopupMenu.popupMenuButtons.fontMenu = null;
          }
          e.stopPropagation();
        }
      });
    });
  };

  /**
   * Register JQuery plugin
   */
  $.fn.popupmenu = function (arg1, arg2, arg3, arg4) {
    const results = [];

    this.each(function () {
      let popupmenu = $(this).data('popupmenu');

      // Initialize a new instance
      if (!popupmenu && $.isPlainObject(arg1)) {
        popupmenu = INKIVE.C.IS_MOBILE
          ? new INKIVE.PopupMenuMobile(this, arg1)
          : new INKIVE.PopupMenuDefault(this, arg1);

        $(this).data('popupmenu', popupmenu);
        results.push(popupmenu);
      } else if (popupmenu && !arg1 && !arg2) {
        // popupmenu already exists
        // no function, trying to init
        results.push(popupmenu);
      } else if (popupmenu && popupmenu[arg1] !== undefined) {
        // Invoke function on existing popupmenu
        const retVal = popupmenu[arg1](arg2, arg3, arg4);
        if (retVal !== undefined) {
          results.push(retVal);
        }
      }
    });

    if (typeof arg1 === 'string') {
      // Return the results from the invoked function calls
      return results.length > 1 ? results : results[0];
    } else {
      return results;
    }
  };

  $.fn.popupmenu.Constructor = INKIVE.C.IS_MOBILE ? INKIVE.PopupMenuMobile : INKIVE.PopupMenuDefault;
}
